export default __webpack_public_path__ + "static/media/crbnacional-2026.2a7a3eff.png";